var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex flex-col",class:{
    'theme-dark': _vm.$route.name === 'BTAB',
    'theme-light': _vm.$route.name !== 'BTAB',
  },attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('footer',{staticClass:"container mx-auto p-2 xl:p-4 mt-auto"},[_c('div',{staticClass:"border-t-2 border-r-2 p-2 m-2"},[_c('p',{staticClass:"text-right text-base"},[_vm._v("Horace Keating "+_vm._s(_vm.currentYear))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }